<template>
  <div id="occupation_apply_dialog">
    <div>
      <a class="iconfont close-button"
         href="javascript:void(null);"
         @click="closeButtonClicked" >&#xe639;</a>

      <div class="main-view">
        <div>
          <el-radio-group v-model="selectedIndex">
            <el-radio v-model="selectedIndex" :disabled="!refereeAble" :label="0">{{'裁判员' + (!refereeAble ? '（未开放）' : '')}}

            </el-radio>
            <el-radio v-model="selectedIndex" :label="1">教练员</el-radio>
          </el-radio-group>
        </div>

        <el-button style="margin-top: 50px;" class="bottom-button next-button" @click="bottomButtonClicked" round>开始认证</el-button>
        <div v-if="selectedIndex == 1" class="bottom-notice">
          该认证需持有中华人民共和国居民身份证，港澳台及外籍人士，可<a href="https://jinshuju.net/f/k5eFrX" target="_blank">点击此处</a>填报相关材料，我们会在提交后5个工作日内进行人工审核确认。
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "applyDialogVue",
    props: {
      refereeAble: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        selectedIndex: 0,
      }
    },
    mounted() {
      if (this.refereeAble) {
        this.selectedIndex = 0;
      } else {
        this.selectedIndex = 1;
      }
    },
    methods: {
      closeButtonClicked() {
        this.$emit("close");
      },
      bottomButtonClicked() {
        console.log('---1');
        let index = this.selectedIndex;
        console.log(index);
        this.$emit('applyCheck', {
          item: index == 0 ? 'judge' : 'coach'
        });
      }
    }
  }
</script>

<style scoped>
  @import url("../../../css/back-next-buttons.css");
  #occupation_apply_dialog {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #occupation_apply_dialog > div {
    background-color: white;
    position: relative;
    width: 90%;
    max-width: 500px;
    /* height: 90%; */
    /* max-height: 300px; */
    border-radius: 4px;
    border: solid 1px #bbb;
  }

  #occupation_apply_dialog .close-button {
    position: absolute;
    top: 12px;
    right: 15px;
    color: #333;
    font-size: 1.5rem;
    z-index: 999;
    text-decoration: none;
  }

  #occupation_apply_dialog .main-view {
    padding-top: 65px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #occupation_apply_dialog  /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #occupation_apply_dialog  /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
    border-color: #fc1a34;
    background-color: #fc1a34;
  }
  #occupation_apply_dialog  /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }

  #occupation_apply_dialog .bottom-notice {
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    margin-top: 15px;
    text-align: center;
    color: #888;
  }

  #occupation_apply_dialog .bottom-notice a {
    color: #FC1A34;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/children/ApplyDialog.vue